<template>
    <div>

        <!-- Upload message -->

        <div class="row" v-if="step=='import'">

            <div class="col-sm-4">
                <p class="font-weight-bold text-sm-right">{{ lang.polaris.common.csv_file }}</p>
            </div>

            <div class="col-sm-8 mb-3">
                <div v-html="lang.polaris.common.csv_file_desc"></div>
            </div>
        </div>

        <!-- Check -->

        <div class="row" v-if="step=='checked'">
            <div class="col text-danger" v-if="errors">
                <div v-if="checkFeedback.data.errors">
                    <div v-for="(userErrors, recordNum) in checkFeedback.data.errors" :key="recordNum">
                        <h4 class="text-uppercase font-weight-bold">
                            Line {{ recordNum + 1 }}
                        </h4>
                        <ul>
                            <li v-for="(message, column) in userErrors" :key="column">
                                <strong>{{ column }}: </strong> {{ message }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <p>{{ checkFeedback.data.message }}</p>
                </div>
            </div>
            <div class="col text-success" v-if="!errors">
                <div v-for="(learners, operation) in checkFeedback.data.feedback" :key="operation">
                    <h4 class="text-uppercase font-weight-bold">
                        <span v-if="!done">to be</span> {{ operation }}
                    </h4>
                    <ul>
                        <li v-for="(learner, index) in learners" :key="index">
                            {{ learner }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    
        <!-- Upload form -->

        <div class="row">

            <div class="col-sm-4">
            </div>

            <div class="col-sm-8 mb-3">
                <form autocomplete="off" v-on:submit.prevent="submitForm" v-if="!errors && !done">

                    <div class="fileinput fileinput-new mt-2" data-provides="fileinput" v-show="step !== 'checked'">
                        <span class="btn btn-default btn-file" style="cursor:pointer;">
                            <span class="fileinput-new">{{ lang.polaris.form.select_file }}</span>
                            <span class="fileinput-exists">{{ lang.polaris.form.select_file }}</span>
                            <input type="file" :id="id+'-input'" name="..." accept=".csv" @change="fileChanged">
                        </span>
                        <span class="fileinput-filename" :id="id+'-name'"></span>
                    </div>
                    
                    <div class="trax-form-actions mt-2" v-show="file">
                        <a href="./import" class="btn btn-default btn-round" v-if="step == 'checked'"> {{ lang.polaris.common.new_upload }} </a>
                        <button type="submit" class="btn btn-primary btn-round"> {{ submitLabel }} </button>
                    </div>
                </form>

                <div class="trax-form-actions mt-2" v-else>
                    <a href="./import" class="btn btn-default btn-round"> {{ lang.polaris.common.new_upload }} </a>
                </div>
            </div>
        </div>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" passed-label="1" :bus="bus">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                lang: lang,
                id: 'users-import-file',
                step: 'import',
                file: null,
                form: {},
                endpoint_check: app_url+'polaris/api/front/users/import/check',
                endpoint_perform: app_url+'polaris/api/front/users/import/update',
                checkFeedback: null,
                errors: false,
                done: false,
                performFeedback: null,
                bus: new Vue()
            }
        },

        computed: {

            checked() {
                return this.step != 'import' && !this.errors;
            },

            submitLabel() {
                return this.checked ? this.lang.polaris.common.record : this.lang.polaris.common.check;
            },

            validLabel() {
                return this.done ? this.lang.polaris.common.recorded : this.lang.polaris.common.checked;
            }
        },

        methods: {

            resetForm() {
                this.file = null;
                this.form = {};
                document.getElementById(this.id+'-input').value = '';
                document.getElementById(this.id+'-name').innerHTML = '';
            },

            fileChanged(e) {
                this.file = true;
                this.form.file = e.target.files[0];
            },

            submitForm() {
                return this.checked ? this.perform() : this.check();
            },

            check() {
                var that = this;
                var formData = new FormData();
                formData.append('file', this.form.file);
                axios.post(
                        this.endpoint_check, 
                        formData,
                        // {headers: {'Content-Type': 'multipart/form-data'}}
                    )
                    .then(function (response) {
                        that.checkFeedback = response.data.data;
                        that.step = 'checked';
                        that.errors = that.checkFeedback.status == 'failed';
                    })
                    .catch(function (error) {
                        if (typeof error.response.data == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        } else if (error.response.data.message) {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data.message);
                        }
                    });
            },

            perform() {
                var that = this;
                var formData = new FormData();
                formData.append('file', this.form.file);
                axios.post(
                        this.endpoint_perform, 
                        formData,
                        // {headers: {'Content-Type': 'multipart/form-data'}}
                    )
                    .then(function (response) {
                        that.checkFeedback = response.data.data;
                        that.errors = that.checkFeedback.status == 'failed';
                        that.done = !that.errors;
                    })
                    .catch(function (error) {
                        if (typeof error.response.data == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        } else if (error.response.data.message) {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data.message);
                        }
                    });
            }

        }

    }
</script>
